import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChartUp = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M15.894 3.418a.75.75 0 0 1 .966-.438l2.752 1.037a.75.75 0 0 1 .438.963l-1.024 2.752a.75.75 0 0 1-1.405-.523l.394-1.06-13.077 5.947a.75.75 0 0 1-.621-1.365l13.076-5.947-1.062-.4a.75.75 0 0 1-.437-.966M20 21.085a.75.75 0 0 0 .75-.75v-8.96a1.39 1.39 0 0 0-1.39-1.39h-1.92a1.39 1.39 0 0 0-1.39 1.39v8.96c0 .414.336.75.75.75zm-.75-9.6v8.1h-1.7v-8.1zm-4.9 8.85a.75.75 0 0 1-.75.75h-3.2a.75.75 0 0 1-.75-.75v-7.04a1.39 1.39 0 0 1 1.39-1.39h1.92a1.39 1.39 0 0 1 1.39 1.39zm-1.5-.75v-6.18h-1.7v6.18zm-5.65 1.5a.75.75 0 0 0 .75-.75v-5.12a1.39 1.39 0 0 0-1.39-1.39H4.64a1.39 1.39 0 0 0-1.39 1.39v5.12c0 .414.336.75.75.75zm-.75-5.76v4.26h-1.7v-4.26z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChartUp;
